module.exports = __webpack_public_path__ + "static/media/loading.7d4027c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading.png
// module id = 64
// module chunks = 0